/*
 * Breadcrumb "browsed from" collection.
 *
 * Product URLs are kept clean (/products/handle — no /collections/x/ segment),
 * so the collection a shopper came from is no longer available on the product
 * page server-side. We remember it client-side instead:
 *
 *   1. On a collection page, store the current collection (handle/title/url).
 *   2. On a product page, rebuild the breadcrumb collection crumb from it,
 *      but only if the product actually belongs to that collection.
 */
(function () {
  var KEY = 'raeBreadcrumbCollection';

  // 1) Remember the collection the shopper is browsing.
  var source = document.getElementById('BreadcrumbCollectionSource');
  if (source) {
    try {
      sessionStorage.setItem(
        KEY,
        JSON.stringify({
          handle: source.dataset.handle || '',
          title: source.dataset.title || '',
          url: source.dataset.url || ''
        })
      );
    } catch (e) {
      /* sessionStorage unavailable (private mode / disabled) — ignore */
    }
  }

  // 2) Rebuild the collection crumb on the product page.
  var nav = document.querySelector('[data-breadcrumb-product]');
  if (!nav) return;

  var stored = null;
  try {
    stored = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  } catch (e) {
    stored = null;
  }
  if (!stored || !stored.title || !stored.url) return;

  // Only surface the remembered collection if this product is actually in it,
  // so an unrelated crumb never leaks across products. When the product has no
  // known collections server-side, trust the stored value.
  var handles = (nav.dataset.productCollections || '')
    .split(',')
    .filter(Boolean);
  if (handles.length && stored.handle && handles.indexOf(stored.handle) === -1) {
    return;
  }

  var crumb = nav.querySelector('[data-breadcrumb-collection]');
  if (!crumb) return;

  var link = crumb.querySelector('[data-breadcrumb-collection-link]');
  var name = crumb.querySelector('[data-breadcrumb-collection-name]');
  if (link) link.setAttribute('href', stored.url);
  if (name) name.textContent = stored.title;

  crumb.hidden = false;
  var separator = nav.querySelector('[data-breadcrumb-collection-separator]');
  if (separator) separator.hidden = false;
})();
